import Vue from 'vue'

Vue.filter('currency', function (value, fixed) {
  fixed = fixed === undefined || window.isNaN(Number(fixed)) ? 2 : Number(fixed)
  fixed = fixed < 0 ? 0 : fixed
  var num = Number(value)
  var minus = num < 0
  num = Math.abs(num.toFixed(fixed))
  var result = ''
  num = (num || 0).toString()
  if (num.indexOf('.') !== -1) {
    var zeroCount = fixed + 1 - (num.length - num.indexOf('.'))
    while (zeroCount > 0) {
      result += '0'
      zeroCount--
    }
    result = num.slice(num.indexOf('.')) + result
    num = num.slice(0, num.indexOf('.'))
  } else if (fixed > 0) {
    var arr = []
    for (var i = 0; i < fixed; i++) {
      arr[i] = '0'
    }
    result += '.' + arr.join('')
  }
  while (num.length > 3) {
    result = ',' + num.slice(-3) + result
    num = num.slice(0, num.length - 3)
  }
  if (num) {
    result = num + result
  }
  if (minus) {
    result = '-' + result
  }
  return result
})

Vue.filter('fixed', function (value, fixed) {
  if (fixed !== 0) {
    fixed = fixed || 2
  }
  var num = Number(value)
  if (window.isNaN(num)) {
    return value
  }
  return num.toFixed(fixed)
})

Vue.filter('persent', function (value) {
  if (value === undefined) {
    return '0%'
  } // 异常值处理
  var num = Number(value)
  if (window.isNaN(num)) {
    return value
  } // 异常值处理
  var str = String(num)
  var pointIndex = str.indexOf('.') // 小数点的位置
  if (pointIndex === -1) { // 没有小数点时
    return num === 0 ? str + '%' : str + '00%' // 对0和其他整数进行处理
  }
  var digits = str.length - 1 - pointIndex // 小数位数
  str = str.replace('.', '') // 去掉小数点
  if (digits <= 2) { // 小数位数小于或等于2，即计算乘以100后是否为整数
    if (digits === 1) {
      str += '0'
    }
    return Number(str) + '%'
  }
  var fontStr = str.substring(0, pointIndex + 2)
  var endStr = str.substring(pointIndex + 2)

  return Number(fontStr + '.' + endStr) + '%'
})

Vue.filter('bankNoFormat', function (val) {
  return ('' + val).replace(/\s/g, '').replace(/(\d{4})(?=\d)/g, '$1 ')
})
// 脱敏处理
Vue.filter('star', function (val, before = 4, after = 4, num = 4) {
  if (!val) {
    return ''
  }
  val = val.toString()
  var leftStr = val.substring(0, before)
  var rightStr = val.substring(val.length - after)
  var star = ''
  for (var i = 0; i < num; i++) {
    star = star + '*'
  }
  return leftStr + star + rightStr
})
